import { render, staticRenderFns } from "./MemberAbsences.vue?vue&type=template&id=38507d69"
import script from "./MemberAbsences.vue?vue&type=script&lang=js"
export * from "./MemberAbsences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports